/* eslint-disable no-useless-computed-key */
export const theme = {
  /* ----- Color Variables ----- */
  colors: {
    primary: '#0052cc',
    secondary: '#ff5a2c',
    alternate: '#111a51',
    default: '#808080',
    basic: '#ffffff',
    dark: '#000000',
    light: '#f1f1f1',
    lighter: '#cfcfcf',
    border: '#3c556c',
    danger: '#e20000',
    warning: '#ffcc00',
    basicRed: '#f22c2c',
    basicGreen: '#1f6700',
    basicBlue: '#012169'
  },
  /* ----- Fonts Typography Variables ----- */
  fonts: {
    dsmallSize: '12px',
    smallestSize: '14px',
    smallerSize: '16px',
    smallSize: '18px',
    defaultSize: '20px',
    secondarySize: '22px',
    hdSubTitle: '24px',
    customTitle: '26px',
    subTitle: '28px',
    lgSubHeading: '32px',
    dSubHeading: '36px',
    hdSubHeading: '38px',
    lgModalTitle: '40px',
    subHeading: '44px',
    mobTitleHeading: '46px',
    lgTitleHeading: '48px',
    hdModalTitle: '50px',
    hdTitleHeading: '52px',
    modalTitle: '58px',
    titleHeading: '62px',
    lgMainHeading: '64px',
    hdMainHeading: '68px',
    mainHeading: '86px',
  },
  lineHeight: {
    smallestHeight: '18px',
    smallerHeight: '20px',
    mobHeight: '21px',
    smallHeight: '22px',
    defaultHeight: '24px',
    hdPrimaryHeight: '26px',
    primaryHeight: '30px',
    secondaryHeight: '32px',
    subHeight: '36px',
    customHeight: '40px',
    dSectionHeight: '44px',
    mobTitleHeight: '50px',
    sectionHeight: '52px',
    lgTitleHeight: '60px',
    hdModalHeight: '62px',
    hdTitleHeight: '66px',
    modalHeight: '70px',
    lgMainHeight: '72px',
    titleHeight: '74px',
    hdMainHeight: '86px',
    mainHeight: '102px',
  },
  /* ----- Border Radius Variables ----- */
  radius: {
    small:'5px',
    normal: '8px',
    hdMedium: '10px',
    medium: '12px',
    hdRound: '14px',
    round: '16px',
    max: '20px',
  },
  /* ----- Media Queries Variables ----- */
  breakpoint: {
    hd: '1600px',
    large: '1440px',
    default: '1200px',
    medium: '1024px',
    tab: '768px',
    mobile: '480px',
  },
}

export const Theme = theme;